var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaceHappyFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 53.1666C42.3469 53.1666 53.1666 42.3469 53.1666 29C53.1666 15.6531 42.3469 4.83331 29 4.83331C15.6531 4.83331 4.83331 15.6531 4.83331 29C4.83331 42.3469 15.6531 53.1666 29 53.1666ZM20.2939 37.5873C20.89 36.7831 22.0251 36.6145 22.8293 37.2105C24.5894 38.5152 26.7141 39.2708 29 39.2708C31.2859 39.2708 33.4105 38.5152 35.1707 37.2105C35.9748 36.6145 37.11 36.7831 37.7061 37.5873C38.3022 38.3915 38.1335 39.5267 37.3293 40.1228C34.9793 41.8646 32.1053 42.8958 29 42.8958C25.8946 42.8958 23.0207 41.8646 20.6707 40.1228C19.8665 39.5267 19.6978 38.3915 20.2939 37.5873ZM38.6666 25.375C38.6666 27.377 37.5847 29 36.25 29C34.9153 29 33.8333 27.377 33.8333 25.375C33.8333 23.3729 34.9153 21.75 36.25 21.75C37.5847 21.75 38.6666 23.3729 38.6666 25.375ZM21.75 29C23.0847 29 24.1666 27.377 24.1666 25.375C24.1666 23.3729 23.0847 21.75 21.75 21.75C20.4153 21.75 19.3333 23.3729 19.3333 25.375C19.3333 27.377 20.4153 29 21.75 29Z",
    fill: "#64D7FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceHappyFilled);
export default __webpack_public_path__ + "static/media/face-happy-filled.b8995141.svg";
export { ForwardRef as ReactComponent };